import { ODataSelect } from "../../../../Providers.Api/ODataQuery";
import { DateHelper } from "../../../../Common/DateHelper";

export class Announcement extends ODataSelect
{
    public Notification_Id = 0;
    public Notification_Title = '';
    public Notification_Priority = 0;
    public Notification_Record_Id = '';
    public Notification_Message = '';
    public Notification_Short_Message = '';
    public Notification_Reminders =  "";
    public Notification_Type = 0;
    public Notification_Status = '';
    public Notification_User_Email = '';
    public Notification_Sent = 0;
    public Notification_Target = 0;
    public Notification_Device = null;
    public Classification = '';
    public Subclassification = '';
    public Available_From = DateHelper.null();
    public Expiry_Date = DateHelper.null();
    public ImageURI = '';
    public ActionURI = '';
    public Node_Id = 0;

    public init(response: any, nodeId: number): Announcement
    {
        super.init(response, nodeId);
        this.Available_From = DateHelper.fromIsoByNode(response.Available_From, nodeId);
        this.Expiry_Date = DateHelper.fromIsoByNode(response.Expiry_Date, nodeId);
        return this;
    }
}

export class UserNotification extends ODataSelect
{
    public Notification_Id = 0;
    public UserNotification_Id = '';
    public Notification_Title = '';
    public Notification_Priority = 0;
    public Notification_Type = 0;
    public Notification_Status = '';
    public Notification_Read_Status = ''
    public Notification_User_Email = '';
    public Notification_Sent = 0;
    public Notification_Target = 0;
    public Classification = '';
    public Subclassification = '';
    public Available_From = DateHelper.null();
    public Expiry_Date = DateHelper.null();
    public ImageURI = '';
    public ActionURI = '';
    public Notification_Data = '';
    public Notification_Category = '';
    public Node_Id = 0;

    public init(response: any, nodeId: number): UserNotification
    {
        super.init(response, nodeId);
        this.Available_From = DateHelper.fromIsoByNode(response.Available_From, nodeId);
        this.Expiry_Date = DateHelper.fromIsoByNode(response.Expiry_Date, nodeId);
        this.Notification_Category = response.Notification_Category ? response.Notification_Category : '';
        return this;
    }
}